export const SPLIT_TEST_OVERRIDE_PREFIX = 'splitTest_';
export const toInternalOverrides = (assignedSplitTests, queryParams) => {
    return Object.keys(assignedSplitTests).reduce((acc, splitTestId) => {
        const cookieName = `${SPLIT_TEST_OVERRIDE_PREFIX}${splitTestId}`;
        const override = queryParams[cookieName];
        if (override !== assignedSplitTests[splitTestId].id) {
            return acc;
        }
        return {
            [cookieName]: assignedSplitTests[splitTestId].id,
            ...acc,
        };
    }, {});
};
export const getDevelopmentOverrides = (cookies) => {
    const assignedVariations = [];
    for (const [key, value] of Object.entries(cookies)) {
        if (key.startsWith(SPLIT_TEST_OVERRIDE_PREFIX)) {
            assignedVariations.push(value);
        }
    }
    return assignedVariations;
};
export const getInternalOverride = (splitTest, cookies, queryParams) => {
    const queryOverride = queryParams[`${SPLIT_TEST_OVERRIDE_PREFIX}${splitTest.id}`];
    const cookieOverride = cookies[`${SPLIT_TEST_OVERRIDE_PREFIX}${splitTest.id}`];
    const internalOverride = splitTest.defaultInternalVariation;
    const variationOverride = queryOverride || cookieOverride || internalOverride;
    if (variationOverride) {
        return splitTest.variations.find(variation => variation.id === variationOverride);
    }
    return undefined;
};
//# sourceMappingURL=overrideVariation.js.map